import React, { useState, useEffect } from "react";
import "./Payment.css";
import apiInstance from "../../services/httpService";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Loader from "../../Loader/Loader";
import paymentService from "../../services/paymentService";
import TaskAltIcon from '@mui/icons-material/TaskAlt';

const Payment = (props) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [severity, setSeverity] = React.useState("success");
  const [message, setMessage] = React.useState("");

  const monthMapObj = {
    "01": "JAN",
    "02": "FEB",
    "03": "MAR",
    "04": "APR",
    "05": "MAY",
    "06": "JUN",
    "07": "JUL",
    "08": "AUG",
    "09": "SEP",
    10: "OCT",
    11: "NOV",
    12: "DEC",
  };
  const data = { token: localStorage.getItem("token") };
  const [isUserpaid, setIsUserPaid] = React.useState(false);
  const [globalPaymentStatus, setGlobalPaymentStatus] = React.useState(false);
  const [isAllConcertPaid, setIsAllConcertPaid] = React.useState(false);
  const [eventsData, setEventsData] = React.useState([]);
  const [confirmedEvents, setConfirmedEvents] = React.useState([]);
  const [upcomingEvents, setUpcomingEvents] = React.useState([]);
  const [eventResourceMap, setEventResourceMap] = React.useState({});

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    getPaymentInfo();
  }, []);

  useEffect(() => {
    if (!confirmedEvents || confirmedEvents.length === 0) return;
    confirmedEvents.forEach((event) => {
      const reqData = {
        token: localStorage.getItem("token"),
        data: { event_id: event.event_id },
      };
      apiInstance
        .axiosCall("api/ccc/user/event_resource", reqData, "POST")
        .then((response) => {
          const resources = response.data.data;
          const hasResources =
            (resources.others?.length > 0) ||
            (resources.scores?.length > 0) ||
            (resources.song_list?.length > 0);
          setEventResourceMap((prev) => ({
            ...prev,
            [event.event_id]: hasResources,
          }));
        })
        .catch(() => {
          setEventResourceMap((prev) => ({
            ...prev,
            [event.event_id]: false,
          }));
        });
    });
  }, [confirmedEvents]);

  const getPaymentInfo = () => {
    apiInstance
      .axiosCall("api/ccc/user/dashboard", data, "POST")
      .then((response) => {
        if (response.data.status == "success") {
          localStorage.setItem("username", response.data.data.name);
          // Subscription events (named "{YEAR}-1" / "{YEAR}-2") are shown in the
          // SubscriptionBanner above the breadcrumb — exclude them here.
          const SUB_RE = /^\d{4}-[12]$/;
          const allEvents = (response.data.data.events || []).filter(
            (e) => !SUB_RE.test(e.name)
          );
          if (allEvents.length > 0) {
            setEventsData(allEvents);
            setConfirmedEvents(
              allEvents.filter(
                (event) =>
                  event.payment_details.registration_status === "confirmed"
              )
            );
            setUpcomingEvents(
              allEvents.filter(
                (event) =>
                  event.payment_details.registration_status !== "confirmed"
              )
            );
            var confimedEventsCount = 0;
            allEvents.map((event) => {
              if (event.payment_details.registration_status == "confirmed") {
                confimedEventsCount += 1;
              }
              if (event.payment_details.charge_type == "paid_concert") {
                setGlobalPaymentStatus(true);
              }
            });
            if (allEvents.length == confimedEventsCount) {
              setIsAllConcertPaid(true);
            }
          }
        } else {
          setSeverity("error");
          setMessage(response.data.message);
          setOpen(true);
        }
      });
  };

  const loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;

      script.onload = () => {
        resolve(true);
      };

      script.onerror = () => {
        resolve(false);
      };

      document.body.appendChild(script);
    });
  };

  const displayRazorPay = (
    amount,
    email,
    phone,
    eventId,
    transactionId,
    orderId,
    eventName,
    eventDescription,
    thumbnail
  ) => {
    const OtherReturnData = {
      eventId: eventId,
      transactionId: transactionId,
      orderId: orderId,
      amount: amount,
    };

    paymentService.createRazorpayInstance(
      amount,
      eventName,
      eventDescription,
      thumbnail,
      email,
      phone,
      razorPayCallback,
      OtherReturnData
    );
  };

  const razorPayCallback = (response, otherData) => {
    console.log(">>> razorPayCallback fired", response, otherData);
    updatePaymentInfo(
      response.razorpay_payment_id,
      otherData.amount,
      otherData.eventId,
      otherData.transactionId,
      otherData.orderId
    );
  };

  const initiatePayment = (
    amount,
    eventId,
    eventName,
    eventDescription,
    thumbnail
  ) => {
    var obj = { payment_amount: amount, event_id: eventId };
    var reqData = {};
    reqData.data = obj;
    reqData.token = data.token;
    apiInstance
      .axiosCall("api/ccc/event/payment/start", reqData, "POST")
      .then((response) => {
        if (response.data.status == "success") {
          const transactiondetails = response.data.data.transaction_details;
          displayRazorPay(
            amount,
            transactiondetails.email,
            transactiondetails.phone,
            eventId,
            transactiondetails.transaction_id,
            transactiondetails.order_id,
            eventName,
            eventDescription,
            thumbnail
          );
        } else {
          setSeverity("error");
          setMessage(response.data.message);
          setOpen(true);
        }
      })
      .catch((error) => {
        console.error("Payment start API failed:", error);
        setSeverity("error");
        setMessage("Could not initiate payment. Please check your connection and try again.");
        setOpen(true);
      });
  };

  const updatePaymentInfo = (
    payment_id,
    amount,
    eventId,
    transactionId,
    orderId
  ) => {
    // setIsLoading(true)
    var transactionRes = {
      status: "success",
      payment_amount: amount,
      transaction_id: transactionId,
      razorpay_id: payment_id,
      event_id: eventId,
      order_id: orderId,
    };
    var reqData = {};
    reqData.data = transactionRes;
    reqData.token = data.token;
    console.log(">>> updatePaymentInfo calling payment/complete with:", reqData);
    apiInstance
      .axiosCall("api/ccc/event/payment/complete", reqData, "POST")
      .then((response) => {
        if (response.data.status == "success") {
          getPaymentInfo();
          setSeverity("success");
          setMessage("Payment done for the event.");
          setOpen(true);
        } else {
          setSeverity("error");
          setMessage(response.data.message);
          setOpen(true);
        }
      })
      .catch((error) => {
        console.error("Payment complete API failed:", error);
        setSeverity("error");
        setMessage("Payment was received but we could not confirm it with the server. Please contact support.");
        setOpen(true);
      });
  };

  const enrollInEvent = (eventId) => {
    const reqData = {
      token: data.token,
      concert_id: eventId,
    };
    apiInstance
      .axiosCall("api/ccc/user/event/enroll", reqData, "POST")
      .then((response) => {
        const resultMessage = response.data.result[0].status_message;
        if (resultMessage === "User assigned to a concert successfully") {
          getPaymentInfo();
          setSeverity("success");
          setMessage("Successfully enrolled in the event.");
          setOpen(true);
        } else {
          setSeverity("error");
          setMessage(resultMessage);
          setOpen(true);
        }
      })
      .catch((error) => {
        console.error("Enroll API failed:", error);
        setSeverity("error");
        setMessage("Could not enroll in the event. Please try again.");
        setOpen(true);
      });
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="row col-lg-12 m-0 px-4">

      {confirmedEvents?.length ? (
        <div className="payment-section px-0 row col-lg-10 mx-auto">
          <div className="payment-label col-lg-12 d-flex align-items-center justify-content-between">
            <div>Enrolled Events</div>
          </div>

          <div className="row event-item-row">
            {/* Start Rendering the upcoming events recieved via props */}
            {eventsData
              ?.filter(
                (event) =>
                  event.payment_details.registration_status === "confirmed"
              )
              ?.map((event) => {
                return (
                  <div
                    className="col-lg-4 my-3 event-item-wrapper"
                    key={"event-" + event.event_id}
                    onClick={()=>props.eventSelected(event.event_id)}
                  >
                    <div className="event-item">
                      <img
                        className="event-img"
                        src={
                          event.event_thumbnail
                            ? event.event_thumbnail
                            : require("../../../assets/Images/Ladies.jpg")
                        }
                      />
                      <div className="row event-info p-3">
                        <div className="col-lg-3 col-3 text-center mb-3">
                          <h3 className="m-0 mt-1 event-month">
                            {monthMapObj[event.date_details.date.split("/")[1]]}
                          </h3>
                          {event.date_details.dummy_date == false ? (
                            <h3 className="m-0 event-date">
                              {event.date_details.date.split("/")[0]}
                            </h3>
                          ) : (
                            ""
                          )}
                          <h3 className="m-0 mt-1 event-year">
                            {event.date_details.date.split("/")[2]}
                          </h3>
                        </div>
                        <div className="col-lg-9 col-9">
                          <h5 className="event-title" title={event.name}>
                            {event.display_name}
                          </h5>
                          {event.payment_details.charge_type !=
                          "paid_concert" ? (
                            <>
                              <div className="payment-done"><TaskAltIcon /> Enrolled</div>
                              {eventResourceMap[event.event_id] && (
                                <div className="view">View Resources</div>
                              )}
                            </>
                          ) : (
                            <>
                              <div className="payment-done"><TaskAltIcon /> Payment Done</div>
                              {eventResourceMap[event.event_id] && (
                                <div className="view">View Resources</div>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            {/* End Rendering the upcoming events recieved via props */}

            {eventsData.length == 0 ? (
              <div className="col-lg-12 my-3">
                <div className="no-events-found col-lg-12">
                  No Events Found.
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      ) : (
        ""
      )}

      {upcomingEvents?.length ? (
        <div className="payment-section row col-lg-10 my-5 mx-auto">
          <div className="payment-label col-lg-12 d-flex align-items-center justify-content-between">
            <div>Upcoming Events</div>
          </div>

          <div className="row event-item-row">
            {/* Start Rendering the upcoming events recieved via props */}
            {eventsData
              ?.filter(
                (event) =>
                  event.payment_details.registration_status !== "confirmed"
              )
              ?.map((event) => {
                return (
                  <div
                    className="col-lg-4 my-3 event-item-wrapper"
                    key={"event-" + event.event_id}
                  >
                    <div className="event-item">
                      <img
                        className="event-img"
                        src={
                          event.event_thumbnail
                            ? event.event_thumbnail
                            : require("../../../assets/Images/Ladies.jpg")
                        }
                      />
                      <div className="row event-info p-3">
                        <div className="col-lg-3 col-3 text-center mb-3">
                          <h3 className="m-0 mt-1 event-month">
                            {monthMapObj[event.date_details.date.split("/")[1]]}
                          </h3>
                          {event.date_details.dummy_date == false ? (
                            <h3 className="m-0 event-date">
                              {event.date_details.date.split("/")[0]}
                            </h3>
                          ) : (
                            ""
                          )}
                          <h3 className="m-0 mt-1 event-year">
                            {event.date_details.date.split("/")[2]}
                          </h3>
                        </div>
                        <div className="col-lg-9 col-9">
                          <h5 className="event-title" title={event.name}>
                            {event.display_name}
                          </h5>
                          {event.payment_details.charge_type !=
                          "paid_concert" ? (
                            <div
                              className="pay-btn"
                              onClick={() => enrollInEvent(event.event_id)}
                            >
                              Enroll
                            </div>
                          ) : (
                            ""
                          )}
                          {event.payment_details.registration_status !=
                            "confirmed" &&
                          event.payment_details.charge_type ==
                            "paid_concert" ? (
                            <div
                              className="pay-btn"
                              onClick={() =>
                                initiatePayment(
                                  event.payment_details.pending_amount,
                                  event.event_id,
                                  event.display_name,
                                  event.description,
                                  event.event_thumbnail
                                )
                              }
                            >
                              Pay ₹ {event.payment_details.pending_amount}
                            </div>
                          ) : (
                            ""
                          )}
                          {event.payment_details.registration_status ==
                            "confirmed" &&
                          event.payment_details.charge_type ==
                            "paid_concert" ? (
                            <div className="pay-btn paid-btn">Payment Done</div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            {/* End Rendering the upcoming events recieved via props */}

            {eventsData.length == 0 ? (
              <div className="col-lg-12 my-3">
                <div className="no-events-found col-lg-12">
                  No Events Found.
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      ) : (
        ""
      )}
      {/* <div className="col-lg-10 col-12 mx-auto px-0">
        <table>
          <thead>
          <tr>
            <th style={{width: '25%'}}><h1>Chorus Number</h1></th>
            <th style={{width: '25%'}}><h1>Part</h1></th>
            <th style={{width: '50%'}}><h1>Chorus Name</h1></th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>4</td>
            <td>I</td>
            <td>And the glory of the Lord</td>
          </tr>
          <tr>
            <td>7</td>
            <td>I</td>
            <td>And he shall purify</td>
          </tr>
          <tr>
            <td>9</td>
            <td>I</td>
            <td>O thou that tellest good tidings</td>
          </tr>
          <tr>
            <td>12</td>
            <td>I</td>
            <td>For unto us a child is born</td>
          </tr>
          <tr>
            <td>17</td>
            <td>I</td>
            <td>Glory to God</td>
          </tr>
          <tr>
            <td>22</td>
            <td>II</td>
            <td>Behold the lamb of God</td>
          </tr>
          <tr>
            <td>24</td>
            <td>II</td>
            <td>Surely He hath borne</td>
          </tr>
          <tr>
            <td>25</td>
            <td>II</td>
            <td>And with His stripes</td>
          </tr>
          <tr>
            <td>26</td>
            <td>II</td>
            <td>All we like sheep</td>
          </tr>
          <tr>
            <td>33</td>
            <td>II</td>
            <td>Lift up your heads</td>
          </tr>
          <tr>
            <td>41</td>
            <td>II</td>
            <td>Let us break their bonds</td>
          </tr>
          <tr>
            <td>44</td>
            <td>II</td>
            <td>Hallelujah</td>
          </tr>
          <tr>
            <td>46</td>
            <td>III</td>
            <td>Since by man came death</td>
          </tr>
          <tr>
            <td>51</td>
            <td>III</td>
            <td>But thanks</td>
          </tr>
          <tr>
            <td>53</td>
            <td>III</td>
            <td>Worthy is the lamb & Amen</td>
          </tr>
          </tbody>
        </table>
      </div> */}
      {/* Toast */}
      <Snackbar open={open} autoHideDuration={5000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity={severity}
          sx={{ width: "fit-content" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default Payment;
